import { LooksIcon } from './LooksIcon';

/**
 * author: Google
 * id 3633613A-B8A7-49D0-8C1B-5415EC76F426
 * name looks
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/looks.svg
 * tags
 * - Weather 
 * - Color 
 */
export const RainbowIcon = LooksIcon;
export default RainbowIcon